/* eslint-disable no-undef */

export const API_AUTH = process.env.REACT_APP_AUTH_URL;
export const API_ROOT = process.env.REACT_APP_CCADMIN_URL;
